import { useTranslation } from 'react-i18next';
import Messages from '../Messages';
import ActivityTimeline from './components/ActivityTimeline';

const ActivityTab = ({
  activityLogs, activitySearch, onSearchChange,
  activityFilter, onFilterChange, actionOptions,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="glass metric-card">
        <h5>📡 {t('admin.tab_activity')}</h5>
        <div className="home-activity-filters">
          <input
            type="search"
            placeholder={t('admin.search_placeholder')}
            value={activitySearch}
            onChange={e => onSearchChange(e.target.value)}
            className="home-activity-search"
          />
          <select value={activityFilter} onChange={e => onFilterChange(e.target.value)} className="home-activity-filter-select">
            <option value="all">All Actions</option>
            {actionOptions.map(a => <option key={a} value={a}>{a.replace(/_/g, ' ')}</option>)}
          </select>
          <span className="home-activity-count">{activityLogs.length} events</span>
        </div>
        <ActivityTimeline logs={activityLogs} searchQuery={activitySearch} filterAction={activityFilter} />
      </div>
      <div className="glass metric-card" style={{ marginTop: '1.5rem' }}>
        <h5>💬 {t('home.messages_title')}</h5>
        <Messages />
      </div>
    </>
  );
};

export default ActivityTab;
